import classNames from 'classnames';
import ModalAuth from 'components/authentication/modal/ModalAuth';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { useAppContext } from 'Main';
import Logo from 'components/common/Logo';
import Section from 'components/common/Section';
import { Col, Row, Spinner } from 'react-bootstrap';

import classes from './AuthSimpleLayout.module.scss';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const { isAuthenticated } = useAuth0();
  const isKanban = pathname.includes('kanban');
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition }
  } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (!isAuthenticated)
    return (
      <Section className="py-0">
        <Row className="flex-center min-vh-100 py-6">
          <div className={classes.container}>
            <Logo logoClassName={classes.logo} />
            <Outlet />
          </div>
        </Row>
      </Section>
    );

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <div className={classNames('content', { 'pb-0': isKanban })}>
        <NavbarTop />
        {/*------ Main Routes ------*/}
        {/* Pages are route-split (routes/index.js) — this boundary keeps the navbars mounted
            while a page's chunk downloads on first visit. */}
        <Suspense
          fallback={
            <Col xs={12}>
              <Spinner
                className="position-absolute start-50"
                animation="grow"
              />
            </Col>
          }
        >
          <Outlet />
        </Suspense>
      </div>
      <ModalAuth />
    </div>
  );
};

export default MainLayout;
